import React from 'react'

class ThemeFooter extends React.Component {

  openIntercomBox(e) {
    e.preventDefault()
    if(!gon.skip_intercom_reporting) {
      Intercom('show')
    }
  }

  renderMyClaim() {
    if(this.props.has_unum_claims) {
      return (<li id="menu_list1_0" className="pb-2">
              <a href="/app/claims" className="sc-gZMcBi iZLfvi">My Claims</a>
            </li>)
    }
  }

  renderBenefitsAndCoverage() {
    if(this.props.has_leave_plan) {
      return(<span>
        <li id="menu_list1_1" className="pb-2">
          <a href="/app/coverage" className="sc-gZMcBi iZLfvi">Coverage</a>
        </li>
        <li id="menu_list1_2" className="pb-2">
          <a href="/leave_plan_benefits" className="sc-gZMcBi iZLfvi">Benefits</a>
        </li>
      </span>)
    }
  }

  renderUnumClaim() {
    if(!this.props.has_leave_plan) {
      return(<li id="menu_list1_3" className="pb-2">
              <a href="/" className="sc-gZMcBi iZLfvi">Start a New Plan</a>
            </li>)
    }
  }

  renderLeavePlanAndTaskList() {
    if(this.props.has_leave_plan) {
      return(<span>
        <li id="menu_list2_0" className="pb-2">
          <a href="/" className="sc-gZMcBi iZLfvi">LeavePlan</a>
        </li>
        <li id="menu_list2_1" className="pb-2">
          <a href="/schedules" className="sc-gZMcBi iZLfvi">Task List</a>
        </li>
      </span>)
    }
  }

  renderPlanningGuides() {
    if(this.props.has_leave_plan){
      return(<li id="menu_list1_4" className="pb-2">
      <a href="/leave_plan_guides" className="sc-gZMcBi iZLfvi">Planning Guides</a>
    </li>)
    }
   }

  render() {
    return (
      <div className="sc-jTzLTM eSlSgP">
        <div className="unum-container">
          <div className="row">
            <div className="col-lg-2 mt-125 mb-250 my-lg-0 order-last order-lg-first">
              <div className="text-center text-lg-left">
                <a href='/app'>
                  <img id="unum_logo_footer" src="https://preview-assets-us-01.kc-usercontent.com:443/e148b783-6d4a-006c-3eaf-1852c4886c80/ec23cfee-c507-4c3f-88f7-c79c710b15ef/unum-logo.svg" />
                </a>
              </div>
            </div>

            <div className="col-lg-6 col-md-7 pt-lg-050">
              <div className="row pl-lg-3">
                <div className="col-sm-6">
                  <div id="menu_list1" className="sc-dnqmqq jRPTWJ">
                    Discover
                    <div className="py-2 h-100">
                      <div className="bar bar-teal bar-h2 bar-w43 bar-rounded"></div>
                    </div>
                    <ul className="sc-iwsKbI Mcgs">
                      { this.renderMyClaim() }
                      { this.renderBenefitsAndCoverage() }
                      { this.renderUnumClaim() }
                      { this.renderPlanningGuides() }
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div id="menu_list2" className="sc-dnqmqq jRPTWJ">
                    Resources
                    <div className="py-2 h-100">
                      <div className="bar bar-teal bar-h2 bar-w43 bar-rounded"></div>
                    </div>
                    <ul className="sc-iwsKbI Mcgs">
                      { this.renderLeavePlanAndTaskList() }
                      <li id="menu_list2_2" className="pb-2">
                        <a onClick={this.openIntercomBox } href="" className="sc-gZMcBi iZLfvi">Search</a>
                      </li>
                      <li id="menu_list2_3" className="pb-2">
                        <a href="/employees/user_info" className="sc-gZMcBi iZLfvi">Profile</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-5 pt-lg-050 mb-3 mt-sm-2 mt-md-0">
              <p id="cta_title" className="sc-gqjmRU fkuBez">Comments?  Suggestions?</p>
              <p id="cta_text" className="sc-VigVT bkLKwn">Please share your feedback with us.</p>
              <a onClick={this.openIntercomBox } className="btn btn-primary w-100 sc-gzVnrw ibZhkv" id="cta_button">Send Feedback</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ThemeFooter